import { CloudUtils } from '@portal/portal-core';
// node-env-flag ships no types; its default export is declared ambiently in the
// co-located node-env-flag.d.ts.
import flag from 'node-env-flag';
// `constants` (bare specifier) resolves to Node's ambient builtin module under
// TS's bundler resolution, shadowing the local `constants` path alias; the `@/`
// alias points unambiguously at `src/constants`.
import { ProductTab, Region } from '@/constants';
import type { Dispatch } from 'redux';

const isSuperAdmin = flag(process.env.ENABLE__SUPER_ADMIN, false);

export const shouldUpdateQueryParams = (): boolean => {
  if (isSuperAdmin) {
    // In the superadmin build, only show/update query params on the admin dashboard
    return window.location.pathname === '/admin';
  }

  // In standard build, *always* update:
  return true;
};

interface DeepLinkAction {
  type: string;
  selectedProductTab?: string;
  selectedRegion?: string;
}

// Updates query params as associated state changes
export const DeepLinkMiddleware =
  () =>
    (next: Dispatch<DeepLinkAction>) =>
      (action: DeepLinkAction): DeepLinkAction => {
        if (!shouldUpdateQueryParams()) {
          return next(action);
        }

        switch (action.type) {
          case ProductTab.SELECTED_PRODUCT_TAB:
            CloudUtils.updateQueryParams({
              productName: action.selectedProductTab,
            });
            break;
          case Region.SELECTED_REGION:
            CloudUtils.updateQueryParams({
              region: action.selectedRegion,
            });
            break;
          default:
            return next(action);
        }

        return next(action);
      };
